import { render, staticRenderFns } from "./InputDataCalendario.vue?vue&type=template&id=0a73a9d8&scoped=true"
import script from "./InputDataCalendario.vue?vue&type=script&lang=js"
export * from "./InputDataCalendario.vue?vue&type=script&lang=js"
import style0 from "./InputDataCalendario.vue?vue&type=style&index=0&id=0a73a9d8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a73a9d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cleverton/paytour-payt-1708/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a73a9d8')) {
      api.createRecord('0a73a9d8', component.options)
    } else {
      api.reload('0a73a9d8', component.options)
    }
    module.hot.accept("./InputDataCalendario.vue?vue&type=template&id=0a73a9d8&scoped=true", function () {
      api.rerender('0a73a9d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/apps/calendario_venda/components/InputDataCalendario.vue"
export default component.exports